import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import commonVi from "./assets/locales/vi/common.json";
import commonEn from "./assets/locales/en/common.json";
import notificationVi from "./assets/locales/vi/notification.json";
import notificationEn from "./assets/locales/en/notification.json";
const languageDetector = new LanguageDetector(null, {
  order: ["localStorage"],
  caches: ["localStorage"],
  lookupLocalStorage: "i18nextLng",
});

const resources = {
  vi: {
    translation: {
      ...commonVi,
      ...notificationVi,
    },
  },
  en: {
    translation: {
      ...commonEn,
      ...notificationEn,
    },
  },
};

// i18n
//   // load translation using http -> see /public/locales
//   // learn more: https://github.com/i18next/i18next-http-backend
//   .use(Backend)
//   // detect user language
//   // learn more: https://github.com/i18next/i18next-browser-languageDetector
//   .use(languageDetector)
//   // pass the i18n instance to react-i18next.
//   .use(initReactI18next)
//   // init i18next
//   // for all options read: https://www.i18next.com/overview/configuration-options
//   .init({
//     // resources,
//     supportedLngs: ['vi', 'en'],
//     fallbackLng: ['vi', 'en'],
//     fallbackNS: 'translation',
//     backend: {
//       // for all available options read the backend's repository readme file
//       loadPath: '/locales/{{lng}}/{{ns}}.json'
//     },
//     debug: false,
//     ns: ['common', 'notification', 'wallet'],
//     defaultNS: 'common',
//     interpolation: {
//       escapeValue: false, // not needed for react as it escapes by default
//     },
//   });

// export default i18n;

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(
    {
      resources,
      detection: {
        // order and from where user language should be detected
        order: ["querystring", "localStorage", "navigator"],

        // keys or params to lookup language from
        lookupQuerystring: "lang",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0,

        // cache user language on
        caches: ["localStorage", "cookie"],
      },
      lng: localStorage.getItem("i18nextLng") || "vi",
      // defaultNS: 'translation',
      fallbackNS: "translation",
      fallbackLng: ["vi", "en"],

      keySeparator: ".", // we do not use keys in form messages.welcome

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    },
    (err, t) => {
      if (err) return console.log("something went wrong loading i18n", err);
      t("key"); // -> same as i18next.t
    }
  );

export default i18n;
